// ======================================================================
// File: src/modules/ipe/dashboard/crm/components/RecentOrdersWidget.jsx
// Purpose:
// CRM Executive Order Fulfillment Widget
// ======================================================================

import React from "react";

export default function RecentOrdersWidget({
  orders = [],
  onViewAll,
  onRowClick,
}) {

  const getNumericValue = (value) => {
    if (!value) return 0;

    let num = parseFloat(
      value.replace(/[^\d.]/g, "")
    );

    if (value.includes("Cr")) {
      num = num * 100;
    }

    return isNaN(num) ? 0 : num;
  };

  const totalValue = orders.reduce(
    (sum, row) =>
      sum + getNumericValue(row.value),
    0
  );

  const maxValue =
    Math.max(
      ...orders.map((x) =>
        getNumericValue(x.value)
      ),
      1
    );

  return (
    <div
      style={{
        background: "#fff",
        borderRadius: "12px",
        padding: "18px",
        boxShadow:
          "0 2px 10px rgba(0,0,0,.06)",
        border: "1px solid #e5e7eb",
      }}
    >
      {/* =====================================================
          HEADER
      ===================================================== */}

      <div
        style={{
          display: "flex",
          justifyContent:
            "space-between",
          alignItems: "center",
          marginBottom: "18px",
        }}
      >
        <h3
          style={{
            margin: 0,
            fontSize: "18px",
            fontWeight: 700,
          }}
        >
          Recent Orders
        </h3>

        <button
          onClick={onViewAll}
          style={{
            border:
              "1px solid #d1d5db",
            background: "#fff",
            padding: "6px 12px",
            borderRadius: "6px",
            cursor: "pointer",
            fontSize: "12px",
            fontWeight: 600,
          }}
        >
          View All
        </button>
      </div>

      {/* =====================================================
          SUMMARY
      ===================================================== */}

      <div
        style={{
          display: "grid",
          gridTemplateColumns:
            "1fr 1fr",
          gap: "12px",
          marginBottom: "18px",
        }}
      >
        <div
          style={{
            background: "#ecfdf5",
            padding: "12px",
            borderRadius: "10px",
          }}
        >
          <div
            style={{
              fontSize: "11px",
              color: "#64748b",
            }}
          >
            Total Orders
          </div>

          <div
            style={{
              fontSize: "24px",
              fontWeight: 700,
              color: "#16a34a",
            }}
          >
            {orders.length}
          </div>
        </div>

        <div
          style={{
            background: "#eff6ff",
            padding: "12px",
            borderRadius: "10px",
          }}
        >
          <div
            style={{
              fontSize: "11px",
              color: "#64748b",
            }}
          >
            Revenue Value
          </div>

          <div
            style={{
              fontSize: "24px",
              fontWeight: 700,
              color: "#2563eb",
            }}
          >
            ₹ {totalValue.toFixed(0)}
            L
          </div>
        </div>
      </div>

      {/* =====================================================
          ORDER LIST
      ===================================================== */}

      <div>
        {orders.map((row, index) => {

          const numericValue =
            getNumericValue(row.value);

          const width =
            (numericValue /
              maxValue) *
            100;

          return (
            <div
              key={row.order_no}
              onClick={() =>
                onRowClick?.(row)
              }
              style={{
                border:
                  "1px solid #e5e7eb",
                borderRadius:
                  "10px",
                padding: "14px",
                marginBottom: "10px",
                cursor: "pointer",
                transition:
                  "all .25s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform =
                  "translateY(-2px)";
                e.currentTarget.style.boxShadow =
                  "0 8px 18px rgba(0,0,0,.08)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform =
                  "translateY(0)";
                e.currentTarget.style.boxShadow =
                  "none";
              }}
            >
              {/* TOP ROW */}

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "12px",
                }}
              >
                <div
                  style={{
                    width: "42px",
                    height: "42px",
                    borderRadius: "50%",
                    background:
                      "#10b981",
                    color: "#fff",
                    display: "flex",
                    alignItems: "center",
                    justifyContent:
                      "center",
                    fontWeight: 700,
                  }}
                >
                  {row.customer
                    ?.substring(0, 1)
                    ?.toUpperCase()}
                </div>

                <div
                  style={{
                    flex: 1,
                  }}
                >
                  <div
                    style={{
                      fontWeight: 700,
                      color: "#111827",
                    }}
                  >
                    {row.customer}
                  </div>

                  <div
                    style={{
                      fontSize: "12px",
                      color: "#64748b",
                    }}
                  >
                    {row.order_no}
                  </div>
                </div>

                <div
                  style={{
                    textAlign: "right",
                  }}
                >
                  <div
                    style={{
                      fontWeight: 700,
                      color: "#16a34a",
                    }}
                  >
                    {row.value}
                  </div>

                  <div
                    style={{
                      fontSize: "11px",
                      color: "#64748b",
                    }}
                  >
                    Booked Revenue
                  </div>
                </div>
              </div>

              {/* VALUE BAR */}

              <div
                style={{
                  marginTop: "12px",
                }}
              >
                <div
                  style={{
                    height: "8px",
                    background:
                      "#e5e7eb",
                    borderRadius:
                      "999px",
                    overflow:
                      "hidden",
                  }}
                >
                  <div
                    style={{
                      width: `${width}%`,
                      height: "100%",
                      background:
                        "#10b981",
                    }}
                  />
                </div>
              </div>

              {/* FOOTER */}

              <div
                style={{
                  display: "flex",
                  justifyContent:
                    "space-between",
                  marginTop: "10px",
                  fontSize: "12px",
                  color: "#64748b",
                }}
              >
                <span>
                  Rank #{index + 1}
                </span>

                <span>
                  Fulfillment:
                  <strong
                    style={{
                      color:
                        "#16a34a",
                    }}
                  >
                    {" "}
                    On Track
                  </strong>
                </span>
              </div>
            </div>
          );
        })}
      </div>

      {/* =====================================================
          FOOTER
      ===================================================== */}

      <div
        style={{
          borderTop:
            "1px solid #e5e7eb",
          marginTop: "12px",
          paddingTop: "12px",
          display: "flex",
          justifyContent:
            "space-between",
          fontSize: "12px",
          color: "#64748b",
        }}
      >
        <span>
          Highest Order Value
        </span>

        <strong>
          {orders[0]?.value}
        </strong>
      </div>
    </div>
  );
}